import SVGIcon from '../SVGIcon';

interface Props {
  width: string;
  height: string;
}

function BigCheckmarkCircleIcon({ height, width }: Props) {
  return (
    <SVGIcon width={width} height={height} viewBox="0 0 160 160" fill="none">
      <path
        d="M80 15C44.1602 15 15 44.1602 15 80C15 115.84 44.1602 145 80 145C115.84 145 145 115.84 145 80C145 44.1602 115.84 15 80 15ZM80 25C110.43 25 135 49.5703 135 80C135 110.43 110.43 135 80 135C49.5703 135 25 110.43 25 80C25 49.5703 49.5703 25 80 25ZM111.406 56.4062L75 92.8125L53.5938 71.4062L46.4062 78.5938L71.4062 103.594L75 107.031L78.5938 103.594L118.594 63.5938L111.406 56.4062Z"
        fill="#3A835D"
      />
    </SVGIcon>
  );
}

export default BigCheckmarkCircleIcon;
